<template>
  <v-container class="ma-0 pa-0" width="100%">
    <!-- list app bar-->
    <v-container
      v-if="!secondary"
      flat
      dense
      class="ma-0 pa-0 d-flex justify-space-between"
      width="100%"
      height="45"
    >
      <!-- right side-->
      <v-container class="pa-0 ma-0 right">
        <v-text-field
          class="saleryName"
          style="width: 230px"
          v-model="name"
          clearable
          :label="$t('name')"
          flat
          outlined
          dense
          height="32"
          :error="nameError"
        />
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-menu offset-y v-if="isMobile || isTablet">
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              outlined
              class="px-1"
              color="grey darken-2"
              height="32"
              v-bind="attrs"
              v-on="on"
              style="min-width: 35px !important; padding: 0 !important"
            >
              <v-icon> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item link @click="getItems">
              <v-list-item-icon>
                <v-icon>mdi-refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('refresh')" />
            </v-list-item>
            <v-list-item link @click="OpenDialog">
              <v-list-item-icon>
                <v-icon>mdi-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('add_items')" />
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          outlined
          v-if="!isMobile && !isTablet"
          @click="openVideo"
          class="ms-2 pa-0"
          color="primary"
          height="32"
          :disabled="true"
        >
          {{ $t("tutorial_setting_salery_factory") }}
        </v-btn>
        <v-btn
          v-if="!isMobile && !isTablet"
          @click="OpenDialog"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("add_items") }}

          <v-icon color="#fff"> mdi-plus </v-icon>
        </v-btn>
      </v-container>
    </v-container>

    <!-- secondary app bar-->
    <v-container
      v-if="secondary"
      flat
      dense
      class="ma-0 pa-0 d-flex justify-space-between"
      width="100%"
      height="45"
    >
      <!-- right side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-toolbar-title class="ma-0 pa-0 mt-1">{{
          titleProp ? $t(titleProp) : $t($route.name, { name: $store.state.studentLabel })
        }}</v-toolbar-title>
        <v-text-field
          class="ms-2"
          v-if="!isMobile && !isTablet"
          style="width: 230px"
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-menu offset-y v-if="isMobile || isTablet">
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              outlined
              class="px-1"
              color="grey darken-2"
              height="32"
              v-bind="attrs"
              v-on="on"
              style="min-width: 35px !important; padding: 0 !important"
            >
              <v-icon> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item link @click="getItems">
              <v-list-item-icon>
                <v-icon>mdi-refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('refresh')" />
            </v-list-item>
            <v-list-item link>
              <export-excel
                ref="refExcel"
                :data="baseData"
                worksheet="abriron.com"
                name="data.xls"
                type="xls"
                class="d-flex align-center w-100"
                :title="$store.state.abrName"
                :total-prop="pageCount"
                :page-prop="excelPage"
                @getAllRows="getAllRows"
              >
                <v-list-item-icon>
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t("excel") }}</v-list-item-title>
              </export-excel>
            </v-list-item>
            <v-list-item v-if="isMobile || isTablet" link @click="printDialog = true">
              <v-list-item-icon>
                <v-icon>mdi-printer-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('print')" />
            </v-list-item>
            <v-list-item link @click="goToWorkshop">
              <v-list-item-icon>
                <v-icon>mdi-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('new_salery_factors')" />
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn
          v-if="!isMobile && !isTablet"
          @click="getItems"
          outlined
          class="px-1 ms-2 pa-0"
          color="grey darken-2"
          height="32"
          @shortkey="getItems"
          v-shortkey="['f5']"
          style="min-width: 35px !important; padding: 0 !important"
        >
          <v-icon> mdi-refresh </v-icon>
        </v-btn>
        <export-excel
          v-if="!isMobile && !isTablet"
          ref="refExcel"
          :data="baseData"
          worksheet="abriron.com"
          name="data-ai.xls"
          type="xls"
          class="float-left pa-0 ma-0"
          :title="$store.state.abrName"
          :total-prop="pageCount"
          :page-prop="excelPage"
          @getAllRows="getAllRows"
        >
          <v-btn outlined class="ma-0 ms-2" color="grey darken-2 " height="32">
            <p class="font-weight-thin mb-0 pa-a me-2">
              {{ $t("excel") }}
            </p>
            <v-icon> mdi-file-excel-outline </v-icon>
          </v-btn>
        </export-excel>
        <v-btn
          v-if="!isMobile && !isTablet"
          outlined
          @click="printDialog = true"
          class="ms-2 pa-0"
          color="grey darken-2"
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("print") }}
          </p>
          <v-icon> mdi-printer-outline </v-icon>
        </v-btn>
        <v-btn
          v-if="!isMobile && !isTablet"
          @click="goToWorkshop"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("new_salery_factors") }}

          <v-icon color="#fff"> mdi-plus </v-icon>
        </v-btn>
      </v-container>
    </v-container>
    <!--excel dialog-->
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :showSumRowProp="false"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import moment from "moment-jalaali";
import mixin from "../../../../../../Mixins/mixin";
import general from "../../../../../../Mixins/general";
export default {
  name: "appBar",
  mixins: [mixin, general],
  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    nameP: {
      type: String,
      default: "",
    },
    salaryFactorItems: {
      type: Object,
      default: () => {},
    },
    validate: {
      type: Boolean,
      default: true,
    },
    beSelected: {
      type: Boolean,
      default: false,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data: () => ({
    titleProp: "",
    printHeaders: "",
    name: null,
    search: null,
    printDialog: false,
    baseData: null,
    pageCount: null,
    excelPage: null,
    nameError: false,
    loading: false,
    snakbar: false,
    snakbarColor: null,
    snakbarText: null,
    items: [],
  }),
  watch: {
    validate(val) {
      if (!val) {
        this.checkRequired(false);
      }
    },
    name(val) {
      this.$emit("name-change", val);
    },
    salaryFactorItems: {
      deep: true,
      handler(val) {
        if (val) {
          let obj = JSON.parse(JSON.stringify(val));
          const data = (obj.items.data || []).map((item) => ({
            ...item,
            created_at: this.generateTime(item.created_at),
            updated_at: this.generateTime(item.updated_at),
          }));
          this.items = data || [];
          this.baseData = data || [];
          this.pageCount = obj.items.last_page || 0;
          this.excelPage = obj.items.current_page || 1;
        }
      },
    },
    loader: {
      deep: true,
      handler(val) {
        if (val) {
          this.loading = val;
        }
      },
    },
    nameP: {
      deep: true,
      handler(val) {
        this.name = val;
      },
    },
    beSelected: {
      deep: true,
      handler(val) {
        if (val) {
          this.checkRequired(true);
        }
      },
    },
  },
  beforeMount() {
    this.printHeaders = [
      { text: this.$t("id"), value: "id" },
      { text: this.$t("name"), value: "name" },
      // { text: this.$t("recorded_by"), value: "recorded_by" },
      { text: this.$t("register-date"), value: "created_at" },
      { text: this.$t("dateUpdate"), value: "updated_at" },
    ];
  },
  methods: {
    checkRequired(val) {
      var app = this;
      if (val) {
        app.snakbarText = app.$t("at_least_selected");
        app.snakbarColor = "red";
        app.snakbar = true;
        app.$emit("update_value");
        return;
      } else {
        app.nameError = !app.name || !app.name.trim();
        app.snakbarText = app.$t("is-required");
        app.snakbarColor = "red";
        app.snakbar = true;
        app.$emit("update_value");
        return !app.nameError;
      }
    },
    generateTime(val) {
      let format = "jYYYY/jMM/jDD";
      let date = val;
      if (!date) return null;
      return moment(date).locale("fa").format(format);
    },
    OpenDialog() {
      this.$emit("open-dialog");
    },
    goToWorkshop() {
      this.$router.push("/payroll/salery_factors/create");
    },
    openVideo() {},
    saveAndNew() {
      this.$emit("click-save-and-new");
    },
    saveAndReturn() {
      this.$emit("click-save-and-return");
    },
    openFilters() {
      this.$emit("open-filters");
    },
    getItems() {
      this.$emit("get-items");
    },
  },
};
</script>
<style scoped>
.right {
  width: auto;
}
</style>
